module.exports = __webpack_public_path__ + "img/26.0105f939.png";